import { IApiRole } from '@styluxinc/api-schema';

type RoleGroup =
  | 'Stylux'
  | 'Merchant'
  | 'Decoration Partner'
  | 'Third Party Support';

type RoleOption = {
  group: RoleGroup;
  roleLabel: string;
  apiRole: IApiRole;
};

export type GroupedRoles = Record<
  RoleGroup,
  { roleLabel: string; apiRole: IApiRole }[]
>;

export const ROLE_OPTIONS: RoleOption[] = [
  { group: 'Stylux', roleLabel: 'Super Admin', apiRole: 'SUPER_ADMIN' },
  { group: 'Merchant', roleLabel: 'Orders', apiRole: 'MERCHANT_ORDERS' },
  { group: 'Merchant', roleLabel: 'Inventory', apiRole: 'MERCHANT_INVENTORY' },
  { group: 'Merchant', roleLabel: 'Offers', apiRole: 'MERCHANT_OFFERS' },
  {
    group: 'Decoration Partner',
    roleLabel: 'Orders',
    apiRole: 'PARTNER_ORDERS',
  },
  {
    group: 'Decoration Partner',
    roleLabel: 'Inventory',
    apiRole: 'PARTNER_INVENTORY',
  },
  {
    group: 'Decoration Partner',
    roleLabel: 'Offers',
    apiRole: 'PARTNER_OFFERS',
  },
  {
    group: 'Third Party Support',
    roleLabel: 'Orders',
    apiRole: 'THIRD_PARTY_SUPPORT_ORDERS',
  },
  {
    group: 'Third Party Support',
    roleLabel: 'Inventory',
    apiRole: 'THIRD_PARTY_SUPPORT_INVENTORY',
  },
  {
    group: 'Third Party Support',
    roleLabel: 'Offers',
    apiRole: 'THIRD_PARTY_SUPPORT_OFFERS',
  },
];
